export const PRESALE_INITIALIZED = 'PRESALE_INITIALIZED'
export const PRESALE_SAVED = 'PRESALE_SAVED'
export const ACCOUNT_LOAD_INITIATED = 'ACCOUNT_LOAD_INITIATED'
export const ACCOUNT_LOADED = 'ACCOUNT_LOADED'
export const SET_INVEST_BUTTON = 'SET_INVEST_BUTTON'


// WEBPACK FOOTER //
// ./src/ActionTypes.js